var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-shimmer",style:(`height: ${_vm.height}%;`)},[_c('div',{staticClass:"body-my-shimmer",style:(`height: ${_vm.height}px;`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }